import { createBox } from '@mui/system';
import { unstable_ClassNameGenerator as ClassNameGenerator } from '../className';
import { createTheme } from '../styles';
import THEME_ID from '../styles/identifier';
var defaultTheme = createTheme();
var Box = createBox({
  themeId: THEME_ID,
  defaultTheme: defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: ClassNameGenerator.generate
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Box;